var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.88,
    cy: 6.25984,
    r: 1.92,
    fill: "#8792AB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.7602,
    cy: 4.34125,
    r: 2.56,
    fill: "#56617B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38086 11.7935C7.38086 10.4362 8.48116 9.33594 9.83846 9.33594H12.413C13.7703 9.33594 14.8706 10.4362 14.8706 11.7935V13.8598C14.8706 14.2569 14.5487 14.5788 14.1516 14.5788H8.09988C7.70278 14.5788 7.38086 14.2569 7.38086 13.8598V11.7935Z",
    fill: "#8792AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.639648 11.5262C0.639648 9.4903 2.29011 7.83984 4.32605 7.83984H6.68997C8.72591 7.83984 10.3764 9.4903 10.3764 11.5262V13.8616C10.3764 14.2587 10.0545 14.5806 9.65735 14.5806H1.35867C0.961564 14.5806 0.639648 14.2587 0.639648 13.8616V11.5262Z",
    fill: "#56617B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIc);
export default __webpack_public_path__ + "static/media/staff-ic.8e18269f3e524fe510045d64c3ba9b2b.svg";
export { ForwardRef as ReactComponent };